import React from "react";
import { getEnv } from "../helpers/env.ts";

export default function Product(props) {

	let product = props.value;

	return (
		<section className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 py-4 px-3">
			<div className="productBox">
				<a href={product.url}>
					<img
						className="w-full h-auto block"
						width="100"
						height="100"
						src={getEnv('PUBLIC_ASSET_HOST') + product?.cover?.linkThumb}
						alt={product?.cover?.description}
					/>
				</a>
				<div className="productBoxContent">
					<a href={product.url}>
						<p className="font-sans tracking-normal mb-1 mt-2">{product.name}</p>
						{product.type && <p className="text-grey-500 mb-0 text-lg">{product.type}</p>}
						{product.width && product.height && <p className="text-grey-500 mb-0 text-lg">
							{product.height} x {product.width} cm
						</p>}
					</a>
				</div>
			</div>
		</section>
	);
}
